import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ActionSheetController, LoadingController, ModalController, ViewController, ToastController } from 'ionic-angular';
import { BusinessProductPaymentCheckoutPage } from '../business-product-payment-checkout/business-product-payment-checkout';
import { BusinessProductPaymentManagerHandler } from '../../providers/business-product-payment-handler';
import { ProductPaymentCheckoutHandler } from '../../providers/product-payment-checkout-handler';
import { ConsumerHandlerProvider } from '../../providers/consumer-handler';
import { BarcodeScanner, BarcodeScannerOptions } from '@ionic-native/barcode-scanner';
import { Globals } from '../../providers/globals';
import { BusinessProductCategoryPage } from '../business-product-category/business-product-category';
import { BusinessProductDetailPage } from '../business-product-detail/business-product-detail';

@Component({
  selector: 'page-business-product-search',
  templateUrl: 'business-product-search.html',
})
export class BusinessProductSearchPage {
	filteredProducts: any = [{
		Count: 0,
		Initial: ''
	}];

	categories: any;
	subCategories: any;
	products: any;
	selectedCategories: any;

	isSearching: boolean = false;
	hasProducts: boolean = false;
	filePath: any;
	loader: any;
	isLoading: boolean = false;
	loadingMsg: any = "Loading...";
	userIsLoading: boolean = false

	cashiPaymentTypeId: number;

	productParams: any = {
		page: 1,
		size: 20,
		cb: null
	}

	categoryParams: any = {
		page: 1,
		size: 20,
		cb: null
	}

	options: BarcodeScannerOptions;
	results: {
	    text: string,
	    cancelled: boolean
	};

  	constructor(
  		public navCtrl: NavController, 
		public navParams: NavParams,
		public productManagerHandler: BusinessProductPaymentManagerHandler,
		public consumerHandlerProvider: ConsumerHandlerProvider,
		public checkoutHandler: ProductPaymentCheckoutHandler,		
		public toastCtrl: ToastController,
		public alertCtrl: AlertController,
		public loadingCtrl: LoadingController,
		public actionSheetCtrl: ActionSheetController,
		public modalCtrl: ModalController,
		public globals: Globals,
		private barcodeScanner: BarcodeScanner,
		public viewCtrl: ViewController
		) {
		this.filePath = this.globals.fileUrl;
		this.checkoutHandler.activeGroupIndex = 0;

		this.productManagerHandler.getPaymentTypes((result)=>{
			this.checkoutHandler.paymentTypes = result;

			var virtualPaymentType = this.checkoutHandler.paymentTypes.filter(function(item) {
			    return item.IsVirtual == true;
			});

			this.cashiPaymentTypeId = virtualPaymentType.length > 0 ? virtualPaymentType[0].Id : 0;
		})
  	}

  	ionViewDidLoad() {
		this.load(null);
	}			

	load(cb){
		// this.loadCategories(null)
		this.loadSubCategories(null)
	}

	loadProducts(cb){
		this.isLoading = true;

		this.productParams.cb = (results)=>{

			for(let product of results){
				product.Initial = product.ProductName.charAt(0)
			}

			this.filteredProducts = results;

			this.isLoading = false;

			if(typeof cb == "function")
				cb()			
		}
		
		this.productManagerHandler.getCashierProducts(this.productParams)
	}

	loadCategories(cb){
		this.isLoading = true;

		this.categoryParams.cb = (result)=>{

			var uniqueCategories = Array.from(new Set(result.map(r=> r.CategoryName)));

			uniqueCategories.sort();

	        var sortedCategories = []

	        for (let uniqueCategory of uniqueCategories) {

	          var subCategoriesFilteredByCategory = result.filter(function (el) {
	              return (el.CategoryName === uniqueCategory);
	          });

	          subCategoriesFilteredByCategory.sort((a,b) =>{
	            return a.SubCategoryName - b.SubCategoryName
	          });

	          for(let subcategory of subCategoriesFilteredByCategory){
					subcategory.Initial = subcategory.SubCategoryName.charAt(0)
				}

	          var categoryObj = {
	              "categoryName": uniqueCategory,
	              "categoryId": subCategoriesFilteredByCategory[0].CategoryId,
	              "subcategories": subCategoriesFilteredByCategory
	          }

	          sortedCategories.push(categoryObj)
	        }

			this.categories = sortedCategories;

			this.isLoading = false;

			if(typeof cb == "function")
				cb()			
		}
		
		this.productManagerHandler.getCategories(this.categoryParams)
	}

	loadSubCategories(cb){
		this.isLoading = true;

		this.categoryParams.cb = (result)=>{

			//var uniqueSubCategories = Array.from(new Set(result.map(r=> r.SubCategoryName)));

			//uniqueSubCategories.sort();

	        //var sortedSubCategories = []

	        //for (let uniqueSubCategory of uniqueSubCategories) {

	          //var productsFilteredBySubCategory = result.filter(function (el) {
	          //     return (el.SubCategoryName === uniqueSubCategory);
	          // });

	          // productsFilteredBySubCategory.sort((a,b) =>{
	          //   return a.SubCategoryName - b.SubCategoryName
	          // });

	          for(let product of result){
					product.Initial = product.ProductName.charAt(0)
				}

	          // var subCategoryObj = {
	          //     "subCategoryName": uniqueSubCategory,
	          //     "subCategoryId": productsFilteredBySubCategory[0].SubCategoryId,
	          //     "products": productsFilteredBySubCategory
	          // }

	        //   sortedSubCategories.push(subCategoryObj)
	        // }

			this.products = result;

			this.isLoading = false;

			if(typeof cb == "function")
				cb()			
		}
		
		this.productManagerHandler.getProducts(this.categoryParams)
	}

	presentCategoryModal($e, subcategory) {
		if(subcategory.ProductCount > 0) {
		   let categoryModal = this.modalCtrl.create(BusinessProductCategoryPage, {category: subcategory});

		    categoryModal.onDidDismiss(productsToAdd => {
             	var index = this.checkoutHandler.order.products.length + 1;

		    	for(let product of productsToAdd){
		     	
		     		this.addProduct(null, product, index);
		     	}
		   });

		   categoryModal.present();
		}
	 }

	 presentProductDetail($e, product) {

	 			var productObj = Object.assign({}, product);
	 			
		   let productModal = this.modalCtrl.create(BusinessProductDetailPage, {product: productObj});

		    productModal.onDidDismiss(productsToAdd => {
		    	if(productsToAdd && productsToAdd.length > 0){
			  //  		var productsToModify = this.checkoutHandler.order.products.filter(function(item) {
					// 	    return item.IndexId == productsToAdd[0].IndexId;
					// 	});

					// for(let product of productsToModify){
					// 	this.checkoutHandler.order.groups[this.checkoutHandler.activeGroupIndex].total -= product.Price;
					// }

	          var index = productsToAdd[0].IndexId ? productsToAdd[0].IndexId : this.checkoutHandler.order.products.length + 1;

			    	for(let product of productsToAdd){
			     	
			     		this.addProduct(null, product, index);
			     	}

			     	this.cleanProduct(productsToAdd[0]);
			     }

			     this.calculateTotal()
		   });

		   productModal.present();
	 }

	 presentProductModal($e, product) {
		// if(subcategory.ProductCount > 0) {
		   let productModal = this.modalCtrl.create(BusinessProductDetailPage, {product: product});

		   productModal.onDidDismiss(productsToAdd => {
			   	if(productsToAdd && productsToAdd.length > 0){
			   		var productsToModify = this.checkoutHandler.order.products.filter(function(item) {
						    return item.IndexId == productsToAdd[0].IndexId;
						});

						// for(let product of productsToModify){
						// 	this.checkoutHandler.order.groups[this.checkoutHandler.activeGroupIndex].total -= product.Price;
						// }

			   		this.checkoutHandler.order.products = this.checkoutHandler.order.products.filter(function(item) {
						    return item.IndexId != productsToAdd[0].IndexId;
						});

						this.checkoutHandler.order.groups[this.checkoutHandler.activeGroupIndex].products = this.checkoutHandler.order.groups[this.checkoutHandler.activeGroupIndex].products.filter(function(item) {
						    return item.IndexId != productsToAdd[0].IndexId;
						});

			     	for(let product of productsToAdd){
			     	
			     		this.addProduct(null, product, product.IndexId);
			     	}

			     	this.cleanProduct(productsToAdd[0]);

			    }

			    this.calculateTotal()
		   });

		   productModal.present();
		// }
	 }

	 cleanProduct(product) {
	 	var clearProduct = this.products.filter(function(item) {
		    return item.Id == product.Id;
		});

		if(clearProduct.length > 0) {
			clearProduct[0].IndexId = null;
			clearProduct[0].Count = null;
			clearProduct[0].Modifiers = []
		}
	 }

	addToOrder(){

   		// this.viewCtrl.dismiss();
   		this.goToCheckout()
	}

	cancel(){

   	// this.viewCtrl.dismiss(null);
   		this.checkoutHandler.clearOrder()

	   	// for(let product of this.products){
	   	// 	product.Count = 0;
	   	// }

	   	this.load(null);
	}

	// modifyProduct($e, product) {

	// 	let productExists = this.checkoutHandler.order.groups[this.checkoutHandler.activeGroupIndex].products.filter(function(item) {
	// 	    return item.IndexId == product.IndexId;
	// 	});

	// 	if(productExists.length == 0) {

	// 		product.Count = null;

	// 		this.checkoutHandler.order.groups[this.checkoutHandler.activeGroupIndex].products.push(product)

	// 		this.selectProduct(null, product)
	// 	} else {
	// 		this.selectProduct(null, productExists[0])
	// 	}
	// }

	addProduct($e, product, index) {

		product.IndexId = product.IndexId ? product.IndexId : index;

		let productExists = this.checkoutHandler.order.groups[this.checkoutHandler.activeGroupIndex].products.filter(function(item) {
		    return item.IndexId == product.IndexId;
		});

		if(productExists.length == 0) {

			//product.Count = null;

			this.checkoutHandler.order.groups[this.checkoutHandler.activeGroupIndex].products.push(product)

			this.selectProduct(null, product)
		} else {
			this.selectProduct(null, productExists[0])
		}
	}

	selectProduct($e, product) {

		// product.IndexId = this.checkoutHandler.order.products.length + 1;

		//product.Count = product.Count ? product.Count + 1 : 1;

		// this.checkoutHandler.order.total += product.Price;

		// this.checkoutHandler.order.groups[this.checkoutHandler.activeGroupIndex].total += product.Price;

		this.checkoutHandler.order.products.push(product);
	}

	removeProduct($e, product) {

		// this.checkoutHandler.order.total -= product.Price;
		this.checkoutHandler.order.groups[this.checkoutHandler.activeGroupIndex].total -= product.Price;

		product.Count = product.Count ? product.Count - 1 : 0;

		if(product.Count == 0) {
			this.checkoutHandler.order.products = this.checkoutHandler.order.products.filter(function(item) {
			    return item.IndexId != product.IndexId;
			});

			this.checkoutHandler.order.groups[this.checkoutHandler.activeGroupIndex].products = this.checkoutHandler.order.groups[this.checkoutHandler.activeGroupIndex].products.filter(function(item) {
			    return item.IndexId != product.IndexId;
			});
		}
	}

	search(ev: any) {
    // Reset items back to all of the items
    this.resetProducts();
    // set val to the value of the searchbar
    let val = ev.target.value;

    // if the value is an empty string don't filter the items
     if (val && val.trim() != '') {
      this.isSearching = true;
      
      let params = {
        page: this.productParams.page,
        size: this.productParams.size,
        businessId: this.checkoutHandler.order.businessId,
        term: val,

        cb: (results)=>{
          this.isLoading = false;

          for(let product of results){
						product.Initial = product.ProductName.charAt(0)
					}

					this.filteredProducts = results; 
        }
      }

      this.productManagerHandler.searchProducts(params);

    } else {
    	this.isSearching = false;
    	// this.load(null);
    }
  }

  clear(ev: any) {

  	this.isSearching = false;

  }

  resetProducts() {
    this.filteredProducts = [];
  }

  testScanDevice(id){
  		var userCode = '1-4137-USER'
  		var userInfo = userCode.split("-");
		// var userInfo = [1, 57]

      	var userParams = {};

		if(userInfo.length>2){
			userParams = {
				businessId: userInfo[0],
				userId: userInfo[1],
				deviceId: 0
			};
		}else{
			userParams = {
				businessId: userInfo[0],
				userId: 0,
				deviceId: userInfo[1]
			}					
		}

    	this.checkoutHandler.order.businessId = 1

    	this.checkoutHandler.order.paymentTypeId = id;

		this.productManagerHandler.getUser(userParams, (result)=>{
	  	
		  	if(result && result.UserId > 0){
		  		this.checkoutHandler.order.consumer = result
		  	} else {

		  		let toast = this.toastCtrl.create({
					message: 'User has not purchased credits',
					duration: 3000,
					position: 'middle'
				});

				toast.present();	

				this.checkoutHandler.order.paymentTypeId = null
		  	}

		  	this.userIsLoading = false;
		})
	}

  async scanDevice(paymentTypeId){
		this.userIsLoading = true

		// this.productManagerHandler.getPaymentTypes((result)=>{
		// 	this.paymentTypes = result;

		// 	var nonVirtualMethods = this.checkoutHandler.paymentTypes.filter(function(item) {
		// 	    return item.IsVirtual == true;
		// 	});

		// 	this.hasOtherPaymentMethods = nonVirtualMethods.length > 0;
		// })

		this.options = {
		  prompt: 'Scan a user to get his account'
		}


		try{
			this.barcodeScanner.scan().then(results => {
				console.log("Payment type: " + paymentTypeId);
	
			 	console.log('Barcode text', results.text);
			 	this.results = results;

				if(this.results.cancelled == true){
					this.userIsLoading = false
					return;
				}

				var userInfo = this.results.text.split("-");

				this.userIsLoading = false
				
				var userParams = {
					businessId: {},
					userId: {},
					deviceId: {}					
				};

				if(userInfo.length>2){
					userParams = {
						businessId: userInfo[0],
						userId: userInfo[1],
						deviceId: 0
					};
				}else{
					userParams = {
						businessId: userInfo[0],
						userId: 0,
						deviceId: userInfo[1]
					}					
				}

				console.log('userInfo.length: ', userInfo.length);
				console.log('userParams.userId: ', userParams.userId);
				console.log('userParams.deviceId: ', userParams.deviceId);

			  	this.checkoutHandler.order.businessId = parseInt(userInfo[0]);

				this.productManagerHandler.getUser(userParams, (result)=>{			  	
				  	if(result && result.UserId > 0){
				  		this.checkoutHandler.order.paymentTypeId = paymentTypeId

			  			this.checkoutHandler.order.consumer = result
				  	} else {
				  		
				  		let toast = this.toastCtrl.create({
							message: 'User has not purchased credits',
							duration: 3000,
							position: 'middle'
						});

						toast.present();	
				  	}

				  	this.userIsLoading = false;
				})

			}).catch(err => {
			    console.log('Error', err);
			});


		}catch(e){
			this.userIsLoading = false
		}
  }

  goToCheckout(){
  	this.checkoutHandler.order.total = 0;
  	this.checkoutHandler.order.products = [];

  	for(var group of this.checkoutHandler.order.groups){

  		this.checkoutHandler.order.total += group.total ? group.total : 0;

  		for(var product of this.checkoutHandler.order.groups[0].products){
	   			for (var i = 0; i < product.Count; i++) { 
					  this.checkoutHandler.order.products.push(product)
					}
	   	}	
	   }

	  if(this.checkoutHandler.order.products.length > 0){

	  	this.navCtrl.push(BusinessProductPaymentCheckoutPage, {
		      "parentPage": this
		    });
		}
  }

  calculateTotal() {
  	this.checkoutHandler.order.groups[this.checkoutHandler.activeGroupIndex].total = 0;

  	for(let product of this.checkoutHandler.order.groups[this.checkoutHandler.activeGroupIndex].products){
  		
  		if(product.Count == 0) {
			this.checkoutHandler.order.products = this.checkoutHandler.order.products.filter(function(item) {
			    return item.IndexId != product.IndexId;
			});

			this.checkoutHandler.order.groups[this.checkoutHandler.activeGroupIndex].products = this.checkoutHandler.order.groups[this.checkoutHandler.activeGroupIndex].products.filter(function(item) {
			    return item.IndexId != product.IndexId;
			});
		}

  		this.checkoutHandler.order.groups[this.checkoutHandler.activeGroupIndex].total += product.Price * product.Count;
  	}
  }

}



// WEBPACK FOOTER //
// ./src/pages/business-product-search/business-product-search.ts